import React from 'react';

import { Tooltip } from '@videoblocks/storywind';

const MissingImageStockItemCard = () => {
  const tooltipMessage = (
    <div>
      <p className="h-full my-auto py-2 px-1">
        This item has been removed from our library. But don't worry! You are
        still licensed to use this content even if it's been removed.
        <br />
        If you have additional questions about your licensing, please contact
        Customer Support.
      </p>
    </div>
  );
  return (
    <Tooltip content={tooltipMessage}>
      <div className="border-4 border-white border-solid">
        <div className="box thumbnail faded load-more">
          <img
            className="object-scale-down bg-gray-400 img-responsive progress-background thumbnail-img shrinking main-img max-h-full w-full"
            src={__ASSETS_COMMON_IMAGES_URL__ + '/icons/nothing-found-icon.svg'}
            alt={'Item Missing'}
            loading="eager"
            width={100}
            height={100}
          />
        </div>
      </div>
    </Tooltip>
  );
};

export default MissingImageStockItemCard;
